<template>
  <v-expansion-panels outlined flat :value="panel">
    <v-expansion-panel>
      <v-expansion-panel-header class="text-selection" color="#D1DCEA">
        <template>
          <div @click="handleHeaderClick" class="container-resumo">
            <div v-if="pagamento.dataPublicacao">
              <p>DATA PUBLICAÇÃO</p>
              <p class="font-weight-bold">{{ pagamento.dataPublicacao | formatDate}}</p>
            </div>
            <div>
              <p>DATA DE PGTO</p>
              <p class="font-weight-bold">{{ pagamento.dataPagamento | formatDate}}</p>
            </div>
            <div>
              <p class="font-weight-bold">{{ pagamento.operadoraAns.nome }}</p>
              <p>{{ pagamento.prestador.nome }}</p>
            </div>
            <div>
              <p>STATUS</p>
              <p class="font-weight-bold" >{{ pagamentoStatusLabel }}</p>
            </div>
            <div>
              <p>TOTAL INFORMADO</p>
              <p class="font-weight-bold">R$ {{ pagamento.valorInformado | formatPrice }}</p>
            </div>
            <div>
              <p>TOTAL PROCESSADO</p>
              <p class="font-weight-bold">R$ {{ totalProcessado | formatPrice }} 
                <v-tooltip bottom v-if="isUsuarioTradimus && this.pagamento.pagamentoComDiferencaValor" color="error">
                  <template v-slot:activator="{ on, attrs }" >
                    <span  style="color:#D0021B" v-bind="attrs" v-on="on" class="pa-0">
                    <v-icon color="error" x-small class="pr-1">fa-exclamation-triangle</v-icon>
                    </span>
                  </template>
                  <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">Valor após conciliação: <b>R$ {{pagamento.valorTradimus | formatPrice }}</b></span>
                </v-tooltip>
              </p>
            </div>
            <div v-if="showValorPendente">
              <p>VALOR PENDENTE</p>
              <p class="font-weight-bold">R$ {{ valorPendente | formatPrice }}</p>
            </div>
          </div>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content :style="'border: 1px solid #D5D5D5; border-bottom-left-radius: inherit; border-bottom-right-radius: inherit'">
        <div class="d-flex mt-4" style="justify-content: space-evenly;">
          <DetalhamentoValoresDeclarados
            class="mr-4"
            title="Declarado"
            :valorInformadoDeclarado="pagamento.valorInformadoDeclarado"
            :valorPagoDeclarado="pagamento.valorPagoDeclarado"
            :valorGlosadoDeclarado="pagamento.valorGlosadoDeclarado"
          />
          <DetalhamentoValoresProcessados
            title="Processado"
            class="mr-4"
            :valorInformadoProcessado="pagamento.valorPagoProducao + pagamento.valorGlosaProducao"
            :valorPagoProcessado="pagamento.valorPagoProducao"
            :valorGlosadoProcessado="pagamento.valorGlosaProducao"
            :valorRecursadoProcessado="pagamento.valorPagoRecurso + pagamento.valorGlosaMantida"
            :valorPagoRecursoProcessado="pagamento.valorPagoRecurso"
            :valorGlosadoRecursoProcessado="pagamento.valorGlosaMantida"
            :showRecursoTable="showRecursoTable"
          />
          <div class="d-flex flex-column align-self-center" style="min-width: 150px;">
              <div>
                <span class="mr-2">
                  Conciliação:
                </span>
                <span class="mr-2">
                  {{ pagamento.percentualConciliadoQuantidade | formatPercent }}
                </span>
              </div>
              <PercentBar
                :total="this.pagamento.percentualConciliadoQuantidade"
                :automatica="this.pagamento.percentualConciliadoQuantidadeAutomatico"
                :manual="this.pagamento.percentualConciliadoQuantidadeManual"
                :textAutomatica="this.itensConciliacaoTexts.textAutomatica"
                :textManual="this.itensConciliacaoTexts.textManual"
                :textRestante="this.itensConciliacaoTexts.textRestante"
              />
          </div>
          <div class="d-flex flex-column align-center" v-if="!isUsuarioTradimus">
            <v-switch
              v-model="isQuitado"
              @change="handleQuitadoChange"
              dense
            />
            <v-label>{{ isQuitado ? 'Quitado' : 'Não quitado' }}</v-label>
          </div>
          <div class="d-flex flex-column">
            <div v-if="showDataPublicacao" class="mb-4">
              <div><b>Publicação</b></div>
              <div>{{ pagamento.dataPublicacao | formatDate }}</div>
              <div v-if="pagamento.responsavelPublicacao">Autor: {{ pagamento.responsavelPublicacao.nome }}</div>
            </div>
            <div v-if="pagamento.dataConclusao" class="d-flex flex-column">
              <div><b>Conclusão</b></div>
              <span>{{ pagamento.dataConclusao | formatDate }}</span>
              <span v-if="pagamento.responsavelConclusao">Autor: {{ pagamento.responsavelConclusao.nome }}</span>
            </div>
          </div>
        </div>
        <v-alert dense text type="error" v-if="this.pagamento.pagamentoComDiferencaValor" icon="fa fa-exclamation-triangle" width="100%"><!--isUsuarioTradimus-->
          Pagamento com diferença de valor após a conciliação. Valor pagamento: <b>R$ {{totalProcessado | formatPrice }}</b> - Valor pós-conciliação: <b>R$ {{pagamento.valorTradimus | formatPrice}}</b>
        </v-alert>
        <v-alert dense text type="error" v-if="this.pagamento.valorPagoDeclarado+this.pagamento.valorGlosadoDeclarado != totalProcessado && isUsuarioTradimus" icon="fa fa-exclamation-triangle" width="100%"><!--isUsuarioTradimus-->
          Pagamento com diferença entre os valores declarados e os valores processados
        </v-alert>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { pagamentoStatusLabels } from '@tradimus/api-conciliacao-client'
import DetalhamentoValoresDeclarados from './DetalhamentoValoresDeclarados.vue'
import DetalhamentoValoresProcessados from './DetalhamentoValoresProcessados.vue'
import PercentBar from '../../common/PercentBar'
import { getItemPercentMessages } from '../../../libs'
import { pagamentoStatusTradimus } from '../../../libs/pagamento-status-tradimus'

export default {
  components: {
    DetalhamentoValoresDeclarados,
    DetalhamentoValoresProcessados,
    PercentBar
  },
  props: {
    pagamento: Object,
    isStatusTradimus: Boolean,
    showValorPendente: Boolean
  },
  data() {
    return {
      pagamentoStatusLabels: {
        ...pagamentoStatusLabels,
        conciliacaoAutomaticaCliente: 'Conciliação automática',
        conciliacaoManualCliente: 'Conciliação manual'
      },
      panel: 0
    }
  },
  computed: {
    itensConciliacaoTexts () {
      return getItemPercentMessages(
        this.pagamento.quantidadeItem,
        this.pagamento.quantidadeItemConciliadoAutomatico,
        this.pagamento.quantidadeItemConciliadoManual
      )
    },
    valorTotal () {
      return this.pagamento.valorPago + this.pagamento.valorGlosado
    },
    valorConciliadoAutomaticoTotal () {
      return this.pagamento.valorPagoConciliadoAutomatico + this.pagamento.valorGlosadoConciliadoAutomatico
    },
    valorConciliadoManualTotal () {
      return this.pagamento.valorPagoConciliadoManual + this.pagamento.valorGlosadoConciliadoManual
    },
    percentLabel () {
      return this.pagamento.percentualConciliadoQuantidade / 100
    },
    isQuitado () {
      return this.pagamento.dataQuitacao !== null
    },
    valorPendente () {
      return this.pagamento.valorPago - this.pagamento.valorPagoConciliado
    },
    totalProcessado () {
      return this.pagamento.valorPago + this.pagamento.valorGlosado
    },
    showRecursoTable () {
      const valoresRecurso = {
        pagoRecurso: this.pagamento.valorPagoRecurso,
        glosaMantida: this.pagamento.valorGlosaMantida
      }

      return Object.values(valoresRecurso).some(valor => valor > 0)
    },
    isUsuarioTradimus () {
      const isUsuarioTradimus = JSON.parse(sessionStorage.getItem('userData'))
      return isUsuarioTradimus.UsuarioTradimus
    },
    pagamentoStatusLabel () {
      if (this.isUsuarioTradimus){
        return pagamentoStatusLabels[this.pagamento.status]
      }
      else if (this.pagamento.status in pagamentoStatusTradimus && !this.isUsuarioTradimus) {
        return 'Em processamento Tradimus'
      }
      else {
        return this.pagamentoStatusLabels[this.pagamento.status]
      }
    },
    showDataPublicacao () {
      return this.isUsuarioTradimus && this.pagamento.dataPublicacao
    }
  },
  methods: {
    handleQuitadoChange () {
      this.$emit('quitarPagamentoClick', !this.isQuitado)
    },
    handleHeaderClick (event) {
      if (window?.getSelection()?.toString()) {
        event.stopPropagation()
        return
      }
    }
  },
  filters: {
    formatPercent(value) {
      const formatter = new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 2 })
      return formatter.format(value/100)
    },
  }
}
</script>

<style scoped>
p {
  margin-bottom: 8px;
}
table, td, th {
  border: 1px solid white;
}

table {
  font-weight: 700;
  width: 100%;
}
thead {
  width: 100%;
}
td {
  padding: 4px 16px 4px 0;
}
.first-row td, tr{
  border-bottom: 1px solid #D1DCEA;
}
.container-resumo {
  display: flex;
  justify-content: space-between;
  padding-right: 24px;
}
.colapse-container {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 24px;
}

.text-selection {
  user-select: text;
}
</style>
